export default "__VITE_ASSET__227a7136__"